/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Carrier_ActiveInputs */

const vi_shipping_carrier_active = /** @type {(inputs: Shipping_Carrier_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dùng`)
};

/**

* @param {Shipping_Carrier_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier_active = /** @type {((inputs?: Shipping_Carrier_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Carrier_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier_active(inputs)
});